import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from '@mui/material';

const ChoreCommentModal = ({ open, onClose, onSave, chore }) => {
    const [comment, setComment] = useState('');

    useEffect(() => {
        if (chore) {
            setComment(chore.comments || '');
        }
    }, [chore]);

    const handleSave = () => {
        onSave(comment);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Add Comment for {chore?.name}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Comment"
                    type="text"
                    fullWidth
                    multiline
                    rows={4}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Add your comments here..."
                    inputProps={{ maxLength: 200 }}
                    helperText={`${comment.length}/200`}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">Cancel</Button>
                <Button onClick={handleSave} color="primary" variant="contained">Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChoreCommentModal;
